import React from 'react'
import FilterMultiDate from "./FilterMultiDate"
import PropTypes from 'prop-types'
import SelectSearch from "./../../../shared/components/SelectSearch"
import InputSearch from "./../../../shared/components/InputSearch"

ReportHubCustPhoneSearch.propTypes = {
    receptionDateFrom: PropTypes.string,
    receptionDateTo: PropTypes.string,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func
}

function ReportHubCustPhoneSearch(props) {
    const {
        listTelco,
        tenants,
        filters,
        setFilters,
        onChangeFilters,
        receptionDateFrom,
        receptionDateTo,
        onChangeFrom,
        onChangeTo
    } = props

    const _handleChangeSelect = (name, value) => {
        onChangeFilters(name, value ? value + '' : '')
    }

    const _handleChangeInput = (filters) => {
        setFilters(filters)
    }

    return (
        <div className="PageFilters">
            <FilterMultiDate
                receptionDateFrom={receptionDateFrom}
                receptionDateTo={receptionDateTo}
                onChangeFrom={onChangeFrom}
                onChangeTo={onChangeTo}
            />
            <div className="itemFilter">
                <SelectSearch
                    name="tenantId"
                    value={filters.tenantId ? parseInt(filters.tenantId) : null}
                    onChange={_handleChangeSelect}
                    label="Khách hàng:"
                    listSelect={tenants}
                />
            </div>
            <div className="itemFilter">
                <InputSearch
                    label="Số ảo"
                    name="shortPhone"
                    filters={filters}
                    value={filters.shortPhone || ''}
                    onChange={_handleChangeInput}
                />
            </div>
            <div className="itemFilter">
                <InputSearch
                    label="Số điện thoại"
                    name="phoneNumber"
                    filters={filters}
                    value={filters.phoneNumber || ''}
                    onChange={_handleChangeInput}
                />
            </div>
            <div className="itemFilter">
                <SelectSearch
                    name="telco"
                    value={filters.telco ? parseInt(filters.telco) : null}
                    onChange={_handleChangeSelect}
                    label="Mạng:"
                    listSelect={listTelco}
                />
            </div>
        </div>
    )
}

export default ReportHubCustPhoneSearch
